/** What to do about a paid order with an invoice still open; Next Step and the close refusal share it. */
export const UNSETTLED_ORDER_FIX_MESSAGE = 'Reverse the balance clear that does not fit one invoice, then clear it again.';
//# sourceMappingURL=unsettled-order-fix-message.js.map